import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Hämtar organisationens ÄTA-inställning (gratis tillval).
 * När `enabled === false` ska UI inte visa några ÄTA-element alls.
 */
export function useAta() {
  const [state, setState] = useState({ enabled: false, loading: true });

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/ata/settings");
      setState({ enabled: !!r.data?.enabled, loading: false });
    } catch {
      setState({ enabled: false, loading: false });
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { ...state, refresh };
}
